import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export const keyMePayments: BaseKeyFunction = () => ["me", "payments"];
